import React, { Component } from 'react';

class Income extends Component {
    render() {
        const { data } = this.props;
        return (
            <div className="row">
                <div className="content">
                    <div className="title">
                        总收入（Total Revenue)
                        <br />
                        Top 10
                    </div>
                    {[
                        'Wyndham Grand Plaza Royale Ningbo 宁波华侨豪生温德姆至尊豪廷大酒店',
                        "Howard Johnson City of Flower Hotel Kunming 昆明花之城豪生酒店",
                        "Wyndham Grand Plaza Royale Hangzhou 杭州温德姆至尊豪廷大酒店",
                        "Howard Johnson Resort Sanya Bay 三亚国光豪生度假酒店",
                        "Wyndham Grand Plaza Royale Oriental Shanghai 上海兴荣温德姆至尊豪廷酒店 ",
                        "Howard Johnson Tian Mu Lake Plaza Liyang 溧阳天目湖豪生大酒店",
                        "Wyndham Grand Plaza Royale Furongguo Changsha 长沙芙蓉国温德姆至尊豪廷大酒店",
                        "Howard Johnson Huachen Plaza Changsha 长沙华晨豪生大酒店",
                        "Wyndham Grand Plaza Royale Colorful Yunnan Kunming 昆明七彩云南温德姆至尊豪廷大酒店",
                        "Howard Johnson Zunyue Hotel Chengdu 成都尊悦豪生酒店",
                    ].map((x, i) => {
                        return (
                            <div className="item" key={x}>
                                <div>{i + 1}</div>
                                <div>
                                    {x.replace(/[^a-zA-Z0-9\s]/g, '')}<br />{x.replace(/[^\u4E00-\u9FA5]/g, "")}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="content">
                    <div className="title">
                        经营利润（GOP）
                        <br />
                        Top 10
                    </div>
                    {[
                        'Howard Johnson City of Flower Hotel Kunming 昆明花之城豪生酒店',
                        "Wyndham Grand Plaza Royale Ningbo 宁波华侨豪生温德姆至尊豪廷大酒店",
                        "Wyndham Grand Plaza Royale Hangzhou 杭州温德姆至尊豪廷大酒店",
                        "Wyndham Grand Plaza Royale Oriental Shanghai 上海兴荣温德姆至尊豪廷酒店 ",
                        "Wyndham Bund East Shanghai 上海兴荣温德姆酒店",
                        "Wyndham Grand Plaza Royale Furongguo Changsha 长沙芙蓉国温德姆至尊豪廷大酒店",
                        "Howard Johnson Zunyue Hotel Chengdu 成都尊悦豪生酒店",
                        "Howard Johnson Paragon Hotel Beijing 北京宝辰饭店",
                        "Howard Johnson Sunshine Plaza Ningbo 宁波阳光豪生大酒店",
                        "Howard Johnson Sandalwoods Hot Spring Resort Shuangyue Bay Huizhou 惠州双月湾檀悦豪生温泉度假酒店",
                    ].map((x, i) => {
                        return (
                            <div className="item" key={x}>
                                <div>{i + 1}</div>
                                <div>
                                    {x.replace(/[^a-zA-Z0-9\s]/g, '')}<br />{x.replace(/[^\u4E00-\u9FA5]/g, "")}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="content">
                    <div className="title">
                        经营利润率（GOP%）
                        <br />
                        Top 10
                    </div>
                    {[
                        "Howard Johnson Riverview Hotel Guangzhou 广州桃花江豪生酒店",
                        "Howard Johnson Zhujiang Plaza ChongQing 重庆珠江豪生大酒店",
                        "Wyndham Bund East Shanghai 上海兴荣温德姆酒店",
                        "Wyndham Grand Plaza Royale Oriental Shanghai 上海兴荣温德姆至尊豪廷酒店 ",
                        "Howard Johnson Paragon Hotel Beijing 北京宝辰饭店",
                        "Howard Johnson City of Flower Hotel Kunming 昆明花之城豪生酒店",
                        "Wyndham Grand Plaza Royale Hangzhou 杭州温德姆至尊豪廷大酒店",
                        "Howard Johnson Jinghope Serviced Residence Suzhou 苏州晋合豪生行政公寓",
                        "Howard Johnson Caida Plaza Shanghai 上海财大豪生大酒店",
                        "Howard Johnson Sandalwoods Hot Spring Resort Shuangyue Bay Huizhou 惠州双月湾檀悦豪生温泉度假酒店",
                    ].map((x, i) => {
                        return (
                            <div className="item" key={x}>
                                <div>{i + 1}</div>
                                <div>
                                    {x.replace(/[^a-zA-Z0-9\s]/g, '')}<br />{x.replace(/[^\u4E00-\u9FA5]/g, "")}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default Income;


// WEBPACK FOOTER //
// ./src/components/table/performanceReview/Income.js